import { FC, PropsWithChildren } from 'react';
import Style from './builderFieldUnits.module.scss';

export type BuilderFieldUnitsProps = {
  units?: string;
  disabled?: boolean;
};

export const BuilderFieldUnits: FC<PropsWithChildren<BuilderFieldUnitsProps>> = ({ units, disabled, children }) => {
  if (!units) {
    return <>{children}</>;
  }

  return (
    <div className={Style.unitsContainer}>
      {children}
      {units && (
        <span className={Style.units} data-disabled={disabled}>
          {units}
        </span>
      )}
    </div>
  );
};
